/**
 * Where the legacy (full-script) loader lands a returning learner.
 *
 * The cursor is a POSITION, not a completion: the player writes the round the
 * playhead is ON (persistLivePositionToDb) and writes nothing when a main-loop
 * round completes. So resume lands ON the cursor's round — the first round not
 * yet completed (r-2026-10-16-ssi-resume-start-of-the-next). This loader used
 * to land on `cursor + 1` ("so the learner doesn't re-do the LEGO they just
 * finished"), a completion-model leftover; the init save then wrote that
 * round back, so every open on this path walked the cursor one round forward
 * with nothing completed (job #304, seen on staging by #287).
 *
 * @returns the round index to land on, or null when neither the LEGO nor a seed
 *   resolves (caller leaves the engine at round 0).
 */
export function legacyResumeRoundIndex(
  roundLegoIds: Array<string | null | undefined>,
  resumeLegoId: string | null,
  startingSeed: number,
  findRoundIndexForSeed: (seed: number) => number,
): number | null {
  if (resumeLegoId) {
    const idx = roundLegoIds.findIndex(id => id === resumeLegoId)
    if (idx >= 0) return idx
  }
  // The LEGO is gone or never recorded: the first round of the cursor's own
  // seed, never the seed after it. A fresh learner (seed 0) starts at seed 1.
  const idx = findRoundIndexForSeed(Math.max(1, startingSeed))
  return idx >= 0 ? idx : null
}
